var map = {
	"./bingbao.png": 3375,
	"./lei.png": 6647,
	"./qing.png": 9654,
	"./shachen.png": 2444,
	"./wu.png": 5635,
	"./xue.png": 2778,
	"./yin.png": 7437,
	"./yu.png": 2128,
	"./yun.png": 4946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4300;